(function () {
  if (window.bnStkPageReady) return;
  window.bnStkPageReady = true;

  document.querySelectorAll('[data-bn-stk-faq]').forEach((root) => {
    root.querySelectorAll('[data-bn-stk-faq-btn]').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = button.nextElementSibling;
        const open = button.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('[data-bn-stk-faq-btn]').forEach((other) => {
          other.setAttribute('aria-expanded', 'false');
          if (other.nextElementSibling) other.nextElementSibling.hidden = true;
        });
        if (!open && panel) {
          button.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  });

  document.querySelectorAll('[data-bn-stk-evidence]').forEach((root) => {
    const panel = root.querySelector('[data-bn-stk-evidence-panel]');
    const title = root.querySelector('[data-bn-stk-evidence-title]');
    const tagline = root.querySelector('[data-bn-stk-evidence-tagline]');
    const studies = root.querySelector('[data-bn-stk-evidence-studies]');
    const iconSlot = root.querySelector('[data-bn-stk-evidence-icon]');
    const bar = root.querySelector('[data-bn-stk-evidence-bar]');
    const panelSlot = root.querySelector('[data-bn-stk-evidence-slot]') || panel.parentElement;
    const mobileEvidence = window.matchMedia('(max-width: 639px)');
    let activeCard = null;
    function positionEvidencePanel() {
      // Only phones use inline expansion; keep the original desktop slot untouched.
      const destination = mobileEvidence.matches && activeCard
        ? activeCard.closest('.bn-stke__cell')
        : panelSlot;
      if (destination && panel.parentElement !== destination) destination.appendChild(panel);
    }
    if (mobileEvidence.addEventListener) mobileEvidence.addEventListener('change', positionEvidencePanel);
    else mobileEvidence.addListener(positionEvidencePanel);
    const dots = {
      theanine: '#0ea5e9',
      'lions-mane': '#10b981',
      rhodiola: '#f43f5e',
      ashwagandha: '#a855f7',
      'alpha-gpc': '#d97706',
      cordyceps: '#f97316',
      prebiotic: '#14b8a6',
      'b-vitamins': '#f43f5e'
    };
    root.querySelectorAll('[data-bn-stk-evidence-card]').forEach((card) => {
      card.setAttribute('aria-expanded', 'false');
      card.addEventListener('click', () => {
        const open = card.classList.contains('is-open');
        root.querySelectorAll('[data-bn-stk-evidence-card]').forEach((other) => {
          other.classList.remove('is-open');
          other.setAttribute('aria-expanded', 'false');
        });
        if (open) {
          panel.classList.remove('is-open');
          activeCard = null;
          positionEvidencePanel();
          const viewLabel = card.querySelector('.bn-stke__view span');
          if (viewLabel) viewLabel.textContent = 'View studies';
          return;
        }
        activeCard = card;
        card.classList.add('is-open');
        card.setAttribute('aria-expanded', 'true');
        root.querySelectorAll('.bn-stke__view span').forEach((label) => { label.textContent = 'View studies'; });
        const viewLabel = card.querySelector('.bn-stke__view span');
        if (viewLabel) viewLabel.textContent = 'Tap to close';
        title.textContent = card.dataset.name || '';
        tagline.textContent = card.dataset.tagline || '';
        const sourceIcon = card.querySelector('.bn-stke__icon');
        if (iconSlot && sourceIcon) {
          iconSlot.className = 'bn-stke__panel-icon ' + sourceIcon.className;
          iconSlot.innerHTML = sourceIcon.innerHTML;
        }
        if (bar) bar.style.background = dots[card.dataset.key] || '#d97706';
        const allMatches = root.querySelectorAll('[data-bn-stk-study][data-key="' + card.dataset.key + '"]');
        // Keep the broader Alpha-GPC count, but feature only the three healthy-adult studies.
        const matches = card.dataset.key === 'alpha-gpc' ? Array.from(allMatches).slice(0, 3) : allMatches;
        studies.className = 'bn-stke__studies is-' + Math.min(matches.length || 1, 3);
        studies.replaceChildren();
        const dotColor = dots[card.dataset.key] || '#d97706';
        matches.forEach((study) => {
          const link = document.createElement('a');
          link.className = 'bn-stke__study';
          link.href = study.dataset.url || '#';
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          const meta = document.createElement('div');
          meta.className = 'bn-stke__meta';
          const journal = document.createElement('span');
          journal.className = 'bn-stke__journal';
          const dot = document.createElement('span');
          dot.className = 'bn-stke__dot';
          dot.style.background = dotColor;
          journal.append(dot, document.createTextNode((study.dataset.journal || '') + ' · ' + (study.dataset.year || '')));
          const ext = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          ext.setAttribute('viewBox', '0 0 24 24');
          ext.setAttribute('class', 'bn-stke__ext');
          ext.setAttribute('fill', 'none');
          ext.setAttribute('stroke', 'currentColor');
          ext.setAttribute('stroke-width', '1.75');
          ext.innerHTML = '<path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>';
          meta.append(journal, ext);
          const heading = document.createElement('h5');
          heading.textContent = study.dataset.title || '';
          const authors = document.createElement('p');
          authors.className = 'bn-stke__authors';
          authors.textContent = study.dataset.authors || '';
          const finding = document.createElement('p');
          finding.className = 'bn-stke__finding';
          const label = document.createElement('strong');
          label.textContent = 'Finding: ';
          finding.append(label, document.createTextNode(study.dataset.finding || ''));
          link.append(meta, heading, authors, finding);
          studies.appendChild(link);
        });
        panel.classList.add('is-open');
        positionEvidencePanel();
      });
    });
  });

  document.querySelectorAll('[data-bn-stk-reviews]').forEach((root) => {
    const scroller = root.querySelector('[data-bn-stk-review-scroller]');
    root.querySelector('[data-bn-stk-review-prev]')?.addEventListener('click', () => scroller.scrollBy({ left: -360, behavior: 'smooth' }));
    root.querySelector('[data-bn-stk-review-next]')?.addEventListener('click', () => scroller.scrollBy({ left: 360, behavior: 'smooth' }));
  });

  const sticky = document.querySelector('[data-bn-stk-sticky]');
  if (sticky) {
    const price = sticky.querySelector('[data-bn-stk-sticky-price]');
    const save = sticky.querySelector('[data-bn-stk-sticky-save]');
    const meta = sticky.querySelector('[data-bn-stk-sticky-meta]');
    const options = Array.from(sticky.querySelectorAll('[data-bn-stk-sticky-option]'));
    const primaryOffer = document.querySelector('[data-bn-stk-primary]') || document.querySelector('[data-bn-stk-offer]');
    const visibilityBoundary = document.querySelector('.bn-stkp');
    const laterOffers = Array.from(document.querySelectorAll('[data-bn-stk-offer]')).filter((offer) => offer !== primaryOffer);
    const threshold = parseInt(sticky.dataset.showAfter || '800', 10);
    const onScroll = () => {
      // Show as shoppers reach Sound familiar, just after the first offer block.
      const show = visibilityBoundary
        ? visibilityBoundary.getBoundingClientRect().top <= 0
        : window.scrollY > threshold;
      const offerInView = laterOffers.some((offer) => {
        const rect = offer.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      });
      sticky.classList.toggle('is-visible', show && !offerInView);
    };
    const updateSticky = (detail) => {
      if (!detail) return;
      if (price) price.textContent = detail.price || '';
      if (save) save.textContent = detail.savings || '';
      if (meta) meta.textContent = 'Subscribe · ' + (detail.name || '');
      options.forEach((option) => {
        const selected = option.dataset.bnStkStickyOption === detail.planKey;
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', onScroll, { once: true });
    onScroll();

    const initialPlan = primaryOffer?.querySelector('[data-bn-stk-plan].is-selected');
    if (initialPlan) {
      updateSticky({
        planKey: initialPlan.dataset.bnStkPlan,
        price: initialPlan.dataset.price,
        savings: initialPlan.dataset.savings,
        name: initialPlan.dataset.name
      });
    }

    document.addEventListener('bn:stk-plan', (event) => {
      updateSticky(event.detail);
    });
    options.forEach((option) => {
      option.addEventListener('click', () => {
        if (!primaryOffer) return;
        const plan = Array.from(primaryOffer.querySelectorAll('[data-bn-stk-plan]')).find(
          (candidate) => candidate.dataset.bnStkPlan === option.dataset.bnStkStickyOption
        );
        plan?.click();
      });
    });
    sticky.querySelector('[data-bn-stk-sticky-add]')?.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('bn:stk-add', { detail: { mode: 'subscription' } }));
    });
  }

  document.querySelectorAll('[data-bn-stk-scroll-offers]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      document.getElementById('offers')?.scrollIntoView({ behavior: 'smooth' });
    });
  });
})();
